module.exports = __webpack_public_path__ + "static/media/AdamC.84ef2521.jpg";